import type { Params } from '@vimcar/mvvm/linkViewModel'
import type { Transitioner } from '#components/TransitionProvider'

import * as mobx from 'mobx'
import PT from 'prop-types'

import type { Nodes } from '../../models/Nodes'
import type { NodeLink } from '../../models/Nodes/NodeLink'
import type { ButtonProps } from '../BottomActions'
import type { ViewState } from '../Root/viewModel'

import {
  ATTRIBUTE_STARTSERVODO,
  ATTRIBUTE_ENDSERVODO,
} from '../../utils/constants'

const OPTION_SKIP_INDEX = 0

export type Props = {
  state: ViewState
  start: boolean
}

export type ViewModel = {
  attributeName: string
  odometerValue?: number | null
  isValid: boolean
  options: Array<NodeLink>
  buttons: Array<ButtonProps>

  handleNext: () => void
  handleClick: (number) => () => void
  _handleSkip: () => void
  handleBack: () => void
  handleFormValid: (boolean) => void
  handleFormChange: (Object) => void
}

type Context = {
  models: { nodes: Nodes }
  transitioner: Transitioner
}

const mkViewModel = (
  params: Params,
  { state, start }: Props,
  { transitioner }: Context,
): ViewModel => {
  const vm = mobx.observable({
    odometerValue: null,
    isValid: false,
    attributeName: start ? ATTRIBUTE_STARTSERVODO : ATTRIBUTE_ENDSERVODO,
    options: state.currentNode && state.currentNode.options,
    get buttons() {
      return vm.options.map((option, index) => ({
        highlighted: option.highlighted,
        handleClick: vm.handleClick(index),
        text: option.text,
        subtext: option.subtext,
      }))
    },

    handleNext: mobx.action(() => {
      state.customAttributes.set(vm.attributeName, vm.odometerValue)
      transitioner.goForward(
        state.currentNode.nextNode && state.currentNode.nextNode.id,
      )
    }),
    handleClick: mobx.action((optionIndex) => () => {
      if (optionIndex === OPTION_SKIP_INDEX) {
        vm._handleSkip()
      }
    }),
    _handleSkip: mobx.action(() => {
      const nextNode =
        state.currentNode.options &&
        state.currentNode.options.length > OPTION_SKIP_INDEX &&
        state.currentNode.options[OPTION_SKIP_INDEX] &&
        state.currentNode.options[OPTION_SKIP_INDEX].link
      if (nextNode) transitioner.goForward(nextNode.id)
    }),
    handleBack: mobx.action(() => {
      state.customAttributes.delete(vm.attributeName)
    }),
    handleFormValid: mobx.action((isValid) => {
      // @ts-expect-error@2322
      vm.isValid = isValid
    }),
    handleFormChange: mobx.action((values) => {
      // @ts-expect-error@2339
      const { odometer } = values
      vm.odometerValue = odometer
    }),
  })

  return vm
}

mkViewModel.contextTypes = {
  models: PT.object.isRequired,
  transitioner: PT.object.isRequired,
}

export default mkViewModel
